module.exports = __webpack_public_path__ + "img/qg1_11.3145e4b1.png";